module.exports = __webpack_public_path__ + "img/treppenhandlauf.96d63603.jpg";